






















import Vue from 'vue'
import Hamburger from '@/components/Hamburger.vue'

export default Vue.extend({
  name: 'Navigation',
  components: {
    Hamburger,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    handleHamburgerToggle() {
      this.isOpen = !this.isOpen
      this.isOpen
        ? document.addEventListener('click', this.handleDocumentClick)
        : document.removeEventListener('click', this.handleDocumentClick)
    },
    handleDocumentClick(event: any) {
      if (!this.$el || !this.elementContains(this.$el, event.target)) {
        this.isOpen = false
        document.removeEventListener('click', this.handleDocumentClick)
      }
    },
    elementContains(elm: any, otherElm: any) {
      if (typeof elm.contains === 'function') {
        return elm.contains(otherElm)
      }
      return false
    },
  },
})
